var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activation-brief-task-delivery-instagram-story-provider',{staticStyle:{"height":"100%"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var brief = ref.brief;
    var contact = ref.contact;
    var step = ref.step;
    var task = ref.task;
    var deliverable = ref.deliverable;
    var errors = ref.errors;
    var errorMessage = ref.errorMessage;
    var isLoading = ref.isLoading;
    var deliverStoryUrl = ref.deliverStoryUrl;
    var deliverInsightsUrl = ref.deliverInsightsUrl;
    var uploadHeaders = ref.uploadHeaders;
    var isDeliverableComplete = ref.isDeliverableComplete;
    var handleInsightsFileChange = ref.handleInsightsFileChange;
    var handleStoryFileChange = ref.handleStoryFileChange;
    var deliverableHasInsights = ref.deliverableHasInsights;
    var handleStartConnection = ref.handleStartConnection;
    var hasUploadedFiles = ref.hasUploadedFiles;
    var uploadedFiles = ref.uploadedFiles;
    var isTaskContentLoading = ref.isTaskContentLoading;
    var taskContent = ref.taskContent;
    var quantityString = ref.quantityString;
    var handleReloadTaskContent = ref.handleReloadTaskContent;
return [_c('activation-brief-task-delivery-instagram-story-view',{attrs:{"brief":brief,"contact":contact,"step":step,"task":task,"deliverable":deliverable,"is-loading":isLoading,"error-message":errorMessage,"deliver-story-url":deliverStoryUrl,"deliver-insights-url":deliverInsightsUrl,"upload-headers":uploadHeaders,"is-deliverable-complete":isDeliverableComplete,"deliverable-has-insights":deliverableHasInsights,"has-uploaded-files":hasUploadedFiles,"uploaded-files":uploadedFiles,"is-task-content-loading":isTaskContentLoading,"task-content":taskContent,"quantity-string":quantityString},on:{"story-file-change":handleStoryFileChange,"insights-file-change":handleInsightsFileChange,"start-connection":handleStartConnection}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }